import React from "react";
import { motion, useReducedMotion } from "framer-motion";

// Restrained scroll reveal (≤280ms, ease-out, once). Disabled under prefers-reduced-motion.
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  className = ""
}: RevealProps) {
  const reduce = useReducedMotion();
  return <motion.div className={className} initial={reduce ? false : {
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "-60px"
  }} transition={{
    duration: 0.28,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} data-id="element-591" data-mp="2f6k76rmlxg17">
      {children}
    </motion.div>;
}